import { createSlice } from "@reduxjs/toolkit";
import {
  fetchMyOrders,
  postNewOrder,
  updateOrder,
  deleteOrder,
} from "../thunks/orderThunks";

const orderSlice = createSlice({
  name: "orders",
  initialState: {
    myOrders: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyOrders.fulfilled, (state, action) => {
        state.myOrders = action.payload;
        state.error = null;
      })
      .addCase(fetchMyOrders.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(postNewOrder.fulfilled, (state, action) => {
        state.myOrders = action.payload;
        state.error = null;
      })
      .addCase(postNewOrder.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateOrder.fulfilled, (state, action) => {
        state.myOrders = action.payload;
        state.error = null;
      })
      .addCase(updateOrder.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteOrder.fulfilled, (state, action) => {
        state.myOrders = action.payload;
        state.error = null;
      })
      .addCase(deleteOrder.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default orderSlice.reducer;
